import './control-indicator.sass'

export { default } from './ControlIndicator'
